/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimaryMaterial } from '../../models/primary-material';

export interface GetListViewGroupByMaterial$Params {
  workCenterId: number;
}

export function getListViewGroupByMaterial(http: HttpClient, rootUrl: string, params: GetListViewGroupByMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<PrimaryMaterial>> {
  const rb = new RequestBuilder(rootUrl, getListViewGroupByMaterial.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrimaryMaterial>;
    })
  );
}

getListViewGroupByMaterial.PATH = '/api/v1/PrimaryMaterial/{workCenterId}/ListView/GroupByMaterial';
